import apiClient from './client';
import type {
    PageviewReportResponse,
    PageviewUrlOption,
} from '@/types/pageview-report';
import { getSelectedNetwork } from '@/lib/gamNetwork';

export interface PageviewReportFilters {
    start: string;
    end: string;
    domains?: string[];
    top_limit?: number;
}

export const getPageviewReport = async (
    filters: PageviewReportFilters
): Promise<PageviewReportResponse> => {
    const params: Record<string, any> = {
        start: filters.start,
        end: filters.end,
        top_limit: filters.top_limit ?? 50,
    };
    if (filters.domains && filters.domains.length > 0) {
        params['domains[]'] = filters.domains;
    }
    const network = getSelectedNetwork();
    if (network) {
        params.network = network;
    }
    const response = await apiClient.get<PageviewReportResponse>(
        '/reports/pageviews',
        { params }
    );
    return response.data;
};

export const getPageviewUrlsByDomain = async (
    domain: string,
    start: string,
    end: string,
    search?: string,
    limit: number = 2000
): Promise<PageviewUrlOption[]> => {
    const response = await apiClient.get<PageviewUrlOption[]>(
        '/reports/pageviews/urls',
        {
            params: { domain, start, end, search, limit },
        }
    );
    return response.data;
};
